var map = {
	"./mira-holdnig-the-door.png": 695,
	"./mira-in-the-living-room-on-saryan.png": 469,
	"./mira-in-the-window-left.png": 235,
	"./mira-judges-you-left.png": 705,
	"./mira-on-the-armchair-3.png": 258,
	"./mira-on-the-armchair-4.png": 29,
	"./mira-on-the-armchair-5.png": 116,
	"./mira-on-the-bed.png": 222,
	"./mira-on-the-chair.png": 508,
	"./mira-on-the-window-bed-right.png": 812,
	"./mira-sleeping-on-the-kitchen-counter.png": 992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 198;